import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
} from "@mui/material";
import logo from "../../assets/buzz.png";
// import mark from "../../assets/mark.jpg";
import enabledlocation from "../../assets/enabledlocation.svg";
import male from "../../assets/maleinstant.svg";
import { width } from "@mui/system";

import {
    GoogleMap,
    InfoWindow,
    InfoWindowF,
    Marker,
    MarkerF,
    useLoadScript,
} from "@react-google-maps/api";
import React, { useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Header } from "../global/Header";
import { Add, ArrowBackIosNewRounded, ArrowDownwardRounded, ArrowRightAltRounded } from "@mui/icons-material";
import '../Users/MapStyle.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";

const SubscriptionCommunities = () => {


    return <CommunityListView />;
};
const Convert_Time_Zone = (isostring) => {
    const isoString = isostring;
    const desiredFormat = "dd MMMM yyyy, hh:mm:ss a";

    const indianTimeZone = "Asia/Kolkata";
    const zonedTime = utcToZonedTime(isoString, indianTimeZone);

    const formattedDate = format(zonedTime, desiredFormat, {
        timeZone: indianTimeZone,
    });

    return formattedDate;
};
function CommunityListView({ data }) {
    const [locations, setlocations] = useState(null);
    const [UserLastLocation, setUserLastLocation] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);

    const FetchCommunities = async () => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/get-paid-communities`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setCommunities(data.response);
            // setloading(false);
        }

    };

    useEffect(() => {
        FetchCommunities();
    }, []);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [communitites, setCommunities] = useState([])

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')


    return (
        <>
            <Box m={"20px"} flexDirection={'column'} display={'flex'}>
              
                <Box display={"flex"} flexDirection={'column'} alignSelf={'stretch'} alignItems={'stretch'}>

                    <Box
                        display={"grid"}
                        gridTemplateColumns="repeat(12,1fr)"
                        gap="20px"
                        pb={"20px"}
                    >
                        {
                            communitites.map((community) => {
                                return (
                                    <Box
                                        // key={`${transaction.txId}-${i}`}
                                        gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 3"}
                                        gridRow="span 2"
                                        display="flex"
                                        alignItems="center"
                                        px="15px"
                                        py={"8px"}
                                        component={Link}
                                        backgroundColor={"#ffffff05"}
                                        borderRadius={"10px"}
                                        to={{
                                            pathname: "/admin/subscription-details",
                                            search: `?community=${community._id}`,
                                            state: { fromDashboard: true },
                                            // console.log(first)
                                        }}

                                        sx={{
                                            textDecoration: 'none', paddingY: "20px", flexDirection: 'column', alignItems: 'center',
                                            justifyContent: 'center', alignContent: 'center', display: 'flex', justifyItems: 'center'
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <img
                                                alt="profile-user"
                                                width="80px"
                                                height="80px"
                                                src={`${community.logo}`}
                                                style={{
                                                    cursor: "pointer", objectFit: 'cover',
                                                    borderRadius: "50%",
                                                    border: "5px solid #ffffff10"
                                                }}
                                            />
                                        </Box>
                                        <Box sx={{ ml: "10px", display: 'flex', flexDirection: 'column', marginTop: "10px" }}>
                                            <Typography color={"#ffffff"}
                                                textAlign={'center'}
                                                fontFamily={"poppins-reg"}
                                                fontSize={"15px"}>{community.title}</Typography>

                                            <Typography color={"#aaaaaa"}
                                                fontFamily={"poppins-reg"}
                                                style={{
                                                    alignSelf: "center",
                                                    border: "1px solid #ffffff10",
                                                    borderRadius: "4px",
                                                    paddingTop: "1px",
                                                    marginTop: "2px",
                                                    paddingBottom: "1px",
                                                    paddingLeft: "6px",
                                                    paddingRight: "6px"
                                                }}
                                                fontSize={"10px"}>{community.admins.length} admins</Typography>
                                        </Box>

                                        {/* <Box sx={{
                                            height: "1.5px",
                                            background: "#aaaaaa20",
                                            alignSelf: 'stretch',
                                            marginY: "15px"
                                        }} />

                                        <Typography color={"#ffffff90"}
                                            alignSelf={'flex-start'}
                                            fontFamily={"poppins-reg"}
                                            fontSize={"11px"}>Community Mail</Typography>

                                        <Typography color={"#ffffff"}
                                            alignSelf={'flex-start'}
                                            fontFamily={"poppins-reg"}
                                            fontSize={"13px"}>{community.communityMail}</Typography>


                                        <Typography color={"#ffffff90"}
                                            alignSelf={'flex-start'}
                                            fontFamily={"poppins-reg"}
                                            marginTop={"20px"}
                                            fontSize={"11px"}>Date Created</Typography>

                                        <Typography color={"#ffffff"}
                                            alignSelf={'flex-start'}
                                            fontFamily={"poppins-reg"}
                                            fontSize={"13px"}>{Convert_Time_Zone(community.createdAt)}</Typography> */}

                                        <Box sx={{
                                            height: "3px", width: "30px", backgroundColor: "#aaaaaa10",
                                            borderRadius: "100px",
                                            marginTop: "20px"
                                        }} />
                                    </Box>
                                );
                            })}
                    </Box>

                </Box>

            </Box>
        </>
    );
}

export default SubscriptionCommunities;
